export const FALLBACK_THEME = 'sap_horizon';
export const FALLBACK_LANG = 'en-US';
export const baseUrl = 'https'+'://'+'main.live.built-in-support.cloud.sap';
export const sourceUrl = `${baseUrl}/dsx-everywhere-sdk/sdk-react-dsx-everywhere.js`;
